module.exports = __webpack_public_path__ + "h5assets/img/pic_2.e170968.png";